/* ==========================================================================
   Backroad — theme scripts (no dependencies)
   ========================================================================== */
(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};
  var strings = theme.strings || {};

  /* ---------- Helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || 'Request failed');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  /* ---------- Drawers & modals ---------- */
  var lastFocus = null;

  function openLayer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var focusTarget = el.querySelector('.drawer__close, .modal__close');
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 50);
  }

  function closeLayer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .modal.is-open')) document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openLayer(document.getElementById(opener.getAttribute('data-drawer-open')));
      return;
    }
    var closer = e.target.closest('[data-drawer-close], [data-modal-close]');
    if (closer) {
      e.preventDefault();
      closeLayer(closer.closest('.drawer, .modal'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.drawer.is-open, .modal.is-open').forEach(closeLayer);
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var input = btn.closest('[data-quantity]').querySelector('input');
    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 1;
    var value = parseInt(input.value, 10) || 0;
    value = btn.hasAttribute('data-qty-plus') ? value + 1 : Math.max(min, value - 1);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart ---------- */
  var cartDrawer = $('[data-cart-drawer]');
  var cartStrings = {};
  try { cartStrings = JSON.parse($('#CartDrawerStrings').innerHTML); } catch (err) { /* defaults below */ }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function renderCart(cart) {
    if (!cartDrawer) return;
    updateCartCount(cart.item_count);
    var body = $('[data-cart-items]', cartDrawer);
    var footer = $('[data-cart-footer]', cartDrawer);

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="cart-drawer__empty"><p>' + escapeHtml(cartStrings.empty || 'Your Cart is Empty') + '</p>' +
        '<button type="button" class="button button--outline" data-drawer-close>' + escapeHtml(cartStrings.continue || 'Continue Shopping') + '</button></div>';
      footer.hidden = true;
      return;
    }

    body.innerHTML = cart.items.map(function (item, index) {
      var line = index + 1;
      var image = item.image || '';
      var sizedImage = image ? image + (image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var variant = item.product_has_only_default_variant ? '' : '<p class="cart-item__variant">' + escapeHtml(item.variant_title) + '</p>';
      return (
        '<div class="cart-item" data-line="' + line + '">' +
          '<a class="cart-item__image" href="' + escapeHtml(item.url) + '">' +
            (sizedImage ? '<img src="' + escapeHtml(sizedImage) + '" alt="" width="80" height="80" loading="lazy">' : '') +
          '</a>' +
          '<div class="cart-item__details">' +
            '<a class="cart-item__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
            variant +
            '<div class="cart-item__row">' +
              '<div class="quantity" data-quantity>' +
                '<button type="button" class="quantity__btn" data-qty-minus aria-label="-">&minus;</button>' +
                '<input class="quantity__input" type="number" min="0" value="' + item.quantity + '" data-cart-line="' + line + '" aria-label="Quantity">' +
                '<button type="button" class="quantity__btn" data-qty-plus aria-label="+">+</button>' +
              '</div>' +
              '<strong>' + formatMoney(item.final_line_price) + '</strong>' +
            '</div>' +
            '<button type="button" class="cart-item__remove" data-cart-remove="' + line + '">' + escapeHtml(cartStrings.remove || 'Remove') + '</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    $('[data-cart-subtotal]', cartDrawer).textContent = formatMoney(cart.total_price);
    footer.hidden = false;
  }

  function refreshCart() {
    return fetchJSON((routes.cart || '/cart') + '.js').then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  function changeLine(line, quantity) {
    var body = cartDrawer && $('[data-cart-items]', cartDrawer);
    if (body) body.classList.add('is-loading');
    return fetchJSON((routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(renderCart).finally(function () {
      if (body) body.classList.remove('is-loading');
    });
  }

  if (cartDrawer) {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-cart-toggle]');
      if (toggle && theme.cartType === 'drawer' && document.body.className.indexOf('template-cart') === -1) {
        e.preventDefault();
        refreshCart();
        openLayer(cartDrawer);
      }
      var remove = e.target.closest('[data-cart-remove]');
      if (remove) changeLine(parseInt(remove.getAttribute('data-cart-remove'), 10), 0);
    });

    cartDrawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-line]');
      if (!input) return;
      changeLine(parseInt(input.getAttribute('data-cart-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
    });
  }

  function addToCart(form, button, errorEl) {
    var label = button.querySelector('[data-add-label]') || button;
    var original = label.textContent;
    button.disabled = true;
    label.textContent = strings.adding || 'Adding…';
    if (errorEl) errorEl.hidden = true;

    var formData = new FormData(form);
    return fetchJSON((routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function () {
      if (theme.cartType !== 'drawer' || !cartDrawer) {
        window.location.href = routes.cart || '/cart';
        return;
      }
      var modal = form.closest('.modal');
      if (modal) closeLayer(modal);
      return refreshCart().then(function () { openLayer(cartDrawer); });
    }).catch(function (err) {
      if (errorEl) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      }
    }).finally(function () {
      button.disabled = false;
      label.textContent = original;
    });
  }

  /* ---------- Variant selection (shared by product page and quick view) ---------- */
  function VariantPicker(root, product, options) {
    this.root = root;
    this.product = product;
    this.options = options || {};
    this.selects = $$('[data-option-index]', root);
    this.idInput = $('[data-variant-id]', root);
    this.button = $('[data-add-button]', root);
    this.priceEl = options.priceEl;
    var self = this;
    this.selects.forEach(function (select) {
      select.addEventListener('change', function () { self.update(); });
    });
  }

  VariantPicker.prototype.currentOptions = function () {
    return this.selects
      .sort(function (a, b) { return a.getAttribute('data-option-index') - b.getAttribute('data-option-index'); })
      .map(function (s) { return s.value; });
  };

  VariantPicker.prototype.findVariant = function () {
    var chosen = this.currentOptions();
    return this.product.variants.filter(function (v) {
      return chosen.every(function (value, i) { return v.options[i] === value; });
    })[0];
  };

  VariantPicker.prototype.update = function () {
    var variant = this.findVariant();
    var label = this.button && (this.button.querySelector('[data-add-label]') || this.button);

    if (!variant) {
      if (this.button) {
        this.button.disabled = true;
        label.textContent = strings.unavailable || 'Unavailable';
      }
      return;
    }

    if (this.idInput) this.idInput.value = variant.id;

    if (this.button) {
      this.button.disabled = !variant.available;
      label.textContent = variant.available ? (strings.addToCart || 'Add to Cart') : (strings.soldOut || 'Sold Out');
    }

    if (this.priceEl) {
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      this.priceEl.innerHTML =
        '<div class="price' + (onSale ? ' price--on-sale' : '') + '">' +
          '<span class="price__current">' + formatMoney(variant.price) + '</span>' +
          (onSale ? ' <s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>' : '') +
        '</div>';
    }

    if (this.options.onVariant) this.options.onVariant(variant);
  };

  /* ---------- Product page ---------- */
  function initProductSection(section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('[data-product-form]', section) || $('form[action*="/cart/add"]', section);
    var gallery = $('[data-gallery]', section);

    function showMedia(mediaId) {
      if (!gallery || !mediaId) return;
      var target = $('[data-media-id="' + mediaId + '"]', gallery);
      if (!target) return;
      $$('.product__media-item', gallery).forEach(function (el) { el.classList.toggle('is-active', el === target); });
      $$('[data-thumb]', gallery).forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-thumb') === String(mediaId));
      });
    }

    if (gallery) {
      gallery.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-thumb]');
        if (thumb) showMedia(thumb.getAttribute('data-thumb'));
      });
    }

    if (!form) return;

    new VariantPicker(form, product, {
      priceEl: $('[data-price-target]', section),
      onVariant: function (variant) {
        if (variant.featured_media) showMedia(variant.featured_media.id);
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
    });

    form.addEventListener('submit', function (e) {
      if (theme.cartType !== 'drawer') return;
      e.preventDefault();
      addToCart(form, $('[data-add-button]', form), $('[data-form-error]', form));
    });
  }

  $$('[data-product-section]').forEach(initProductSection);

  /* ---------- Quick view ---------- */
  var quickModal = $('[data-quick-view-modal]');

  function renderQuickView(product, url) {
    var content = $('[data-quick-view-content]', quickModal);
    var variant = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    var images = (product.media || [])
      .filter(function (m) { return m.media_type === 'image' || m.preview_image; })
      .map(function (m) { return { id: m.id, src: m.src || (m.preview_image && m.preview_image.src) }; });
    if (!images.length && product.featured_image) images = [{ id: 0, src: product.featured_image }];

    function sized(src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }

    var hasOptions = !(product.variants.length === 1 && product.variants[0].title === 'Default Title');
    var optionsHtml = hasOptions ? product.options.map(function (option, i) {
      var name = typeof option === 'string' ? option : option.name;
      var values = typeof option === 'string'
        ? product.variants.map(function (v) { return v.options[i]; }).filter(function (v, idx, arr) { return arr.indexOf(v) === idx; })
        : option.values;
      return '<div class="field"><label class="field__label" for="QV-opt-' + i + '">' + escapeHtml(name) + '</label>' +
        '<div class="select"><select id="QV-opt-' + i + '" data-option-index="' + i + '">' +
        values.map(function (val) {
          return '<option value="' + escapeHtml(val) + '"' + (variant.options[i] === val ? ' selected' : '') + '>' + escapeHtml(val) + '</option>';
        }).join('') +
        '</select><svg class="icon" aria-hidden="true" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-width="2" d="m6 9 6 6 6-6"/></svg></div></div>';
    }).join('') : '';

    content.innerHTML =
      '<div class="quick-view__gallery">' +
        '<div class="quick-view__image">' + (images[0] ? '<img src="' + escapeHtml(sized(images[0].src, 900)) + '" alt="' + escapeHtml(product.title) + '" data-qv-main>' : '') + '</div>' +
        (images.length > 1 ? '<div class="quick-view__thumbs">' + images.map(function (img) {
          return '<button type="button" data-qv-thumb="' + escapeHtml(img.src) + '" data-media-id="' + img.id + '"><img src="' + escapeHtml(sized(img.src, 160)) + '" alt=""></button>';
        }).join('') + '</div>' : '') +
      '</div>' +
      '<div class="quick-view__info">' +
        '<h2 class="product__title">' + escapeHtml(product.title) + '</h2>' +
        '<div class="product__price" data-qv-price></div>' +
        '<form class="product-form" action="' + escapeHtml(routes.cartAdd || '/cart/add') + '" method="post" data-qv-form>' +
          '<input type="hidden" name="id" value="' + variant.id + '" data-variant-id>' +
          optionsHtml +
          '<div class="field"><label class="field__label" for="QV-qty">Qty</label>' +
            '<div class="quantity" data-quantity><button type="button" class="quantity__btn" data-qty-minus aria-label="-">&minus;</button>' +
            '<input class="quantity__input" id="QV-qty" type="number" name="quantity" value="1" min="1">' +
            '<button type="button" class="quantity__btn" data-qty-plus aria-label="+">+</button></div></div>' +
          '<p class="form-message form-message--error" data-form-error hidden></p>' +
          '<button type="submit" class="button button--full" data-add-button><span data-add-label>' + escapeHtml(strings.addToCart || 'Add to Cart') + '</span></button>' +
        '</form>' +
        '<a class="quick-view__more" href="' + escapeHtml(url) + '">View full details</a>' +
      '</div>';

    var form = $('[data-qv-form]', content);
    var main = $('[data-qv-main]', content);
    var picker = new VariantPicker(form, product, {
      priceEl: $('[data-qv-price]', content),
      onVariant: function (v) {
        var src = (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) || (v.featured_image && v.featured_image.src);
        if (src && main) main.src = sized(src, 900);
      }
    });
    picker.update();

    content.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-qv-thumb]');
      if (thumb && main) main.src = sized(thumb.getAttribute('data-qv-thumb'), 900);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(form, $('[data-add-button]', form), $('[data-form-error]', form));
    });
  }

  if (quickModal) {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quick-view]');
      if (!trigger) return;
      e.preventDefault();
      var url = trigger.getAttribute('data-quick-view');
      var content = $('[data-quick-view-content]', quickModal);
      content.innerHTML = '<div class="quick-view__loading">Loading…</div>';
      openLayer(quickModal);
      fetchJSON(url + '.js').then(function (product) {
        renderQuickView(product, url);
      }).catch(function () {
        window.location.href = url;
      });
    });
  }

  /* ---------- Slideshow ---------- */
  function initSlideshow(el) {
    var slides = $$('[data-slide]', el);
    if (slides.length < 2) return;
    var dots = $$('[data-slide-to]', el);
    var index = 0;
    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = el.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    var speed = parseInt(el.getAttribute('data-speed'), 10) || 6000;

    function go(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var active = n === index;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        $$('a, button', s).forEach(function (a) { a.tabIndex = active ? 0 : -1; });
      });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
    }

    function start() { if (autoplay) { stop(); timer = setInterval(function () { go(index + 1); }, speed); } }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-slide-prev]')) { go(index - 1); start(); }
      if (e.target.closest('[data-slide-next]')) { go(index + 1); start(); }
      var dot = e.target.closest('[data-slide-to]');
      if (dot) { go(parseInt(dot.getAttribute('data-slide-to'), 10)); start(); }
    });
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    el.addEventListener('focusin', stop);
    el.addEventListener('focusout', start);

    var touchX = null;
    el.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); start(); }
      touchX = null;
    });

    go(0);
    start();
  }

  $$('[data-slideshow]').forEach(initSlideshow);

  /* ---------- Collection sorting ---------- */
  $$('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || el.children.length) return;
    fetch(url).then(function (res) { return res.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-slideshow]', e.target).forEach(initSlideshow);
    $$('[data-product-section]', e.target).forEach(initProductSection);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-slide]');
    if (!slide) return;
    var show = slide.closest('[data-slideshow]');
    var dots = $$('[data-slide-to]', show);
    var idx = $$('[data-slide]', show).indexOf(slide);
    if (dots[idx]) dots[idx].click();
  });
})();
